import axios from "axios";
const API_URL = `${process.env.REACT_APP_API_URL}/user`;
const SUBSCRIPTION_API_URL = `${process.env.REACT_APP_API_URL}/subscription`;

const listUser = (data?: any) => {
  return axios.post(`${API_URL}/list`, data).then((response) => {
    return response.data;
  });
};

const createUser = (data?: any) => {
  return axios.post(`${API_URL}/add`, data).then((response: any) => {
    return response;
  });
};

const viewUser = (id: any) => {
  return axios.get(`${API_URL}/view/${id}`).then((response) => {
    return response.data;
  });
};

const deleteUser = (id: any) => {
  return axios.put(`${API_URL}/delete/${id}`).then((response) => {
    return response.data;
  });
};
const userReferralListApi = (user_id?: any) => {
  console.log("user-referral-bonus-list user_id", user_id)
  return axios.post(`${API_URL}/user-referral-bonus-list`, user_id).then((response) => {
    return response;
  });
};

const userTransactionListApi = (data?: { user_id?: any, start_date?: string, end_date?: string, page?: number, limit?: number }) => {
  console.log("list-transactions Apiii params", data)
  // The response interceptor in helpers/api_helper.ts already unwraps to response.data,
  // so this resolves with the API payload ({ status, data, totalCount, totalAmount }).
  return axios.post(`${API_URL}/list-transactions`, data || {}).then((response: any) => {
    return response;
  });
};

const getRoutesSlotStoreByPincode = (data?: any) => {
  console.log("list-getRoutesSlotStoreByPincode Apiii user_id", data)
  return axios.post(`${SUBSCRIPTION_API_URL}/get-slot-store-route`, data).then((response) => {
    return response;
  });
};

const createManualSubscription = (data?: any) => {
  console.log("list-createManualSubscription Apiii user_id", data)
  return axios.post(`${SUBSCRIPTION_API_URL}/create-manual-subscription`, data).then((response) => {
    return response;
  });
};

const listSubscriptionPlansListActive = (data?: any) => {
  console.log("list-listSubscriptionPlansListActive Apiii user_id", data)
  return axios.post(`${SUBSCRIPTION_API_URL}/get-plan-list`, data).then((response) => {
    return response;
  });
};
const upgradeDowngradeSubscription = (data?: any) => {
  console.log("list-upgradeDowngradeSubscription Apiii datass", data)
  return axios.post(`${SUBSCRIPTION_API_URL}/upgrade-downgrade-subscription`, data).then((response) => {
    return response;
  });
};


const updateUser = (id: any, data: any) => {
  return axios.put(`${API_URL}/update/${id}`, data).then((response) => {
    return response.data;
  });
};

export {
  listUser, createUser, viewUser, deleteUser, updateUser, userReferralListApi, userTransactionListApi,
  getRoutesSlotStoreByPincode, createManualSubscription, listSubscriptionPlansListActive,
  upgradeDowngradeSubscription,
};

